<div class='options' [class.selected]='selected' [class.checked]='checked' [class.horizontal]="horizontal" [class.vertical]="vertical"
[ngClass]="className" role='group'>
    <ng-container *ngFor='let option of params.options'>
        <ng-container *ngIf="option.field">
            <button type="button" (click)='toggle(option)'
                    (animationend)='content.reportUpdated(null)'
                    [disabled]='!enabled || option.disabled'
                    [class]='option.class || ""'
                    [class.active]='active'
                    [class.selected]='!!value[option.field]'
                    [class.echo]='option.echo'
                    [class.not-selected]='selected && !value[option.field]'>
                <span [innerHtml]='option.display'></span>
            </button>
        </ng-container>
    </ng-container>
    <button type="button" (click)='onSubmit()'
            (animationend)='content.reportUpdated(null)'
            [class]='"next-quest"'
            [disabled]='!enabled || !checked'
            [class.active]='active'>
        <span>Nächste Frage <img src='/images/chatbot/Copeia-Play.svg' alt='Copeia-Play.svg' /></span>
    </button>
    <a class='fixme' *ngIf='params.fixme' (click)='params.fixme()' [innerHTML]='params.fixmeMessage'></a>
</div>
<chatbot-message-back *ngIf="content.backButton && selected" [content]='content' [params]='params'></chatbot-message-back>
